// extracted by mini-css-extract-plugin
module.exports = {"AppButton_text_small":"AppButton_text_small_KhKQX"};